// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getFunctions, type Functions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

/** חייב להתאים לאזור שבו מפרסים את Cloud Functions (ברירת מחדל us-central1). */
const FUNCTIONS_REGION = process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCsCvLfGxNZPyDRPMSkXAgDEBgSLJBPqH4",
  authDomain: "my-repair-lab.firebaseapp.com",
  projectId: "my-repair-lab",
  storageBucket: "my-repair-lab.firebasestorage.app",
  messagingSenderId: "788072570938",
  appId: "1:788072570938:web:a6f3a02641bb0daf379503",
  measurementId: "G-WDZT17FML1"
};

// אתחול האפליקציה
const app = initializeApp(firebaseConfig);

/**
 * אתחול lazy — קריאה ל־getFunctions בשלב טעינת המודול יצרה מעגל webpack
 * (__WEBPACK_DEFAULT_EXPORT__ before initialization). קוראים רק בפועל בזמן שימוש.
 */
let firebaseFunctionsSingleton: Functions | null = null;
export function getFirebaseFunctions(): Functions {
  if (!firebaseFunctionsSingleton) {
    firebaseFunctionsSingleton = getFunctions(app, FUNCTIONS_REGION);
  }
  return firebaseFunctionsSingleton;
}

// יצוא של auth ו-firestore
const auth = getAuth(app);

// Firestore עם מטמון מקומי (קריאות חוזרות + עבודה offline ללא תעבורה מיותרת)
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

const storage = getStorage(app);

// ייצוא db כך שנוכל להשתמש בו בקבצים אחרים
//export default firebaseConfig; // יש לוודא שהייצוא הוא בצורה כזאת
export { app, auth, db, firebaseConfig, FUNCTIONS_REGION, storage };